var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterielBureau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22179 11.2929C2.26917 9.34027 2.26917 6.17444 4.22179 4.22182C6.17441 2.2692 9.34024 2.2692 11.2929 4.22182L18.3639 11.2929C19.5355 12.4645 19.5355 14.364 18.3639 15.5355C17.1924 16.7071 15.2929 16.7071 14.1213 15.5355L7.05022 8.46446C6.65969 8.07394 6.65969 7.44077 7.05022 7.05025C7.44074 6.65972 8.07391 6.65972 8.46443 7.05025L15.5355 14.1213C15.926 14.5118 16.5592 14.5118 16.9497 14.1213C17.3402 13.7308 17.3402 13.0976 16.9497 12.7071L9.87864 5.63603C8.70707 4.46446 6.80758 4.46446 5.636 5.63603C4.46443 6.80761 4.46443 8.7071 5.636 9.87867L14.1213 18.364C15.2929 19.5355 17.1924 19.5355 18.3639 18.364C18.7515 17.9764 19.0095 17.5118 19.1407 17.0204C19.2832 16.4869 19.8313 16.1698 20.3649 16.3123C20.8984 16.4548 21.2155 17.0029 21.073 17.5365C20.8535 18.3585 20.4209 19.1354 19.7781 19.7782C17.8255 21.7308 14.6597 21.7308 12.7071 19.7782L4.22179 11.2929Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterielBureau);
export default __webpack_public_path__ + "static/media/materiel-bureau.33aa03d1efa974677f0a7c475085dbbe.svg";
export { ForwardRef as ReactComponent };